import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { ScrewFamily, UpdateScrewFamilyBody } from "../../../../http/screwConnector/types/screwFamilies";
import useScrewConnectorScrewFamiliesApi from "../../../../http/screwConnector/useAdminScrewFamilies";
import ScrewFamilyForm from "./ScrewFamilyForm";

// No dedicated /visibility or /order sub-endpoints in the screw-shear-connector API — the inline
// editors re-send the full entity through the standard update endpoint.
const toUpdateBody = (item: ScrewFamily): UpdateScrewFamilyBody => ({
  name: item.name,
  nameIt: item.nameIt,
  nameDe: item.nameDe,
  nameEs: item.nameEs,
  nameFr: item.nameFr,
  description: item.description,
  descriptionIt: item.descriptionIt,
  descriptionDe: item.descriptionDe,
  descriptionEs: item.descriptionEs,
  descriptionFr: item.descriptionFr,
  threadType: item.threadType,
  material: item.material,
  materialIt: item.materialIt,
  materialDe: item.materialDe,
  materialEs: item.materialEs,
  materialFr: item.materialFr,
  coating: item.coating,
  coatingIt: item.coatingIt,
  coatingDe: item.coatingDe,
  coatingEs: item.coatingEs,
  coatingFr: item.coatingFr,
  ccCode: item.ccCode,
  tcCode: item.tcCode,
  scEuCode: item.scEuCode,
  ecUsCode: item.ecUsCode,
  wdUsCode: item.wdUsCode,
  standardReference: item.standardReference,
  image: item.image,
  visibility: item.visibility,
  order: item.order,
  connectionTypes: item.connectionTypes,
  substrates: item.substrates,
});

const AdminScrewFamilies: FC = () => {
  const i18n = useI18n();
  const t = i18n.translation.screwConnectorModule;
  const screwFamiliesApi = useScrewConnectorScrewFamiliesApi();

  return (
    <AdminCrudTable<ScrewFamily>
      filterPrefix="screw_families"
      useList={screwFamiliesApi.useScrewFamilies}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.name}</TableHeadCell>
          <TableHeadCell align="left">{t.screwFamilies.fields.threadType}</TableHeadCell>
          <TableHeadCell align="left">{t.screwFamilies.fields.material}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.name}</TableCell>
          <TableCell>{t.threadTypes[item.threadType]}</TableCell>
          <TableCell>{item.material}</TableCell>
        </>
      )}
      visibilityAndOrder={{
        updateVisibility: (item, visibility) =>
          screwFamiliesApi.updateScrewFamily(item.id, { ...toUpdateBody(item), visibility }),
        updateOrder: (item, order) => screwFamiliesApi.updateScrewFamily(item.id, { ...toUpdateBody(item), order }),
      }}
      onDelete={(item) => screwFamiliesApi.deleteScrewFamily(item.id)}
      deleteTitle={t.screwFamilies.singular}
      canAdd
      renderForm={(item, onClose) => <ScrewFamilyForm screwFamily={item} onClose={onClose} />}
    />
  );
};

export default AdminScrewFamilies;
